export default "__VITE_ASSET__DFXLpLB5__"